declare global {
    interface Window {
        environment: string;
        appVersion: string;
        unsupportedMode: boolean;
    }
}

class DevInfoStore {
    get envClassName(): string {
        return window.environment.toLocaleLowerCase();
    }

    get appVersion(): string {
        return window.appVersion;
    }

    get appEnvironment(): string {
        return window.environment.toUpperCase();
    }

    get isDevelopment(): boolean {
        return this.appEnvironment === 'DEVELOPMENT';
    }

    get isIntegration(): boolean {
        return this.appEnvironment === 'INTEGRATION';
    }

    get isProduction(): boolean {
        return this.appEnvironment === 'PRODUCTION';
    }
}

export const devInfoStore = new DevInfoStore();
